<template>
  <div class="d-flex button-container">
    <AOSButton
      :class="getButtonClasses"
      size="small"
      :translate-with-default="getTranslateText"
      :icon-label-id="!!iconClasses ? 'icon' : ''"
      :button-color="buttonColor"
      :button-style="buttonStyle"
      :label-id="labelId"
      :icon-class="iconClasses"
      :is-disabled="isDisabled"
      :busy="isBusy"
      @click="click"
    />
  </div>
</template>

<script lang="ts">
import AOSButton from '@gecko-akh/aos-button';
import { PropType } from 'vue';
import { ClickCallback } from '../callbacks';

export default {
  components: {
    AOSButton,
  },

  props: {
    labelId: {
      type: String,
      default: ''
    },
    buttonColor: {
      type: String as PropType<'expi-blue' | 'green' | 'red'>,
      default: 'expi-blue'
    },
    buttonStyle: {
      type: String as PropType<'outline' | 'link'>,
      default: ''
    },
    buttonClasses: {
      type: String,
      default: ''
    },
    iconClasses: {
      type: String,
      default: ''
    },
    isBusy: {
      type: Boolean,
      default: false
    },
    isDisabled: {
      type: Boolean,
      default: false
    },
    click: {
      type: Function as PropType<ClickCallback>,
      default: () => console.log('clicked function not implemented'), // eslint-disable-line no-console
    },
  },
  data() {
    return {
      image: this.imgName,
      busy: false,
    }
  },

  computed: {
    getButtonClasses() {
      if (!!this.iconClasses) {
        return `${this.buttonClasses} pb-0 pt-1`
      }

      return `${this.buttonClasses} py-0`
    }
  },

  methods: {
    getTranslateText: (label: string) => {
      // TODO: add correct method when AEM is implemented
      return label
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../../scss/expinet.scss';
@import '@gecko-akh/shared-styles/src/styles/AOS.vars.scss';

.button-container {
  height: 32px;
}
</style>

<style lang="scss">
@import '../../scss/expinet.scss';
@import '@gecko-akh/shared-styles/src/styles/AOS.vars.scss';

// not scoped, so we can override the AOS button styling
// since we do not need to support Barrierefreiheit yet

.button-container {
  .button-1 {
    font-size: 12px;
  }
}
</style>
